import { loadBrowserErrors } from './loadBrowserErrors';

const maxBufferedErrors = 10;

type MonitoringOptions = {
  dsn: string | undefined;
  environment: string | undefined;
  hostname: string;
  load: () => Promise<{ initializeBrowserErrors: (dsn: string, errors: Error[]) => void }>;
};

// Keep early failures while the optional SDK loads, without blocking page rendering.
export function startBrowserErrorMonitoring(
  options: MonitoringOptions = {
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    hostname: window.location.hostname,
    load: loadBrowserErrors,
  }
) {
  const { dsn, environment, hostname, load } = options;
  if (
    environment !== 'production' ||
    !dsn ||
    !['scaledtech.consulting', 'www.scaledtech.consulting'].includes(hostname)
  ) {
    return;
  }

  const errors: Error[] = [];
  const remember = (value: unknown) => {
    if (value instanceof Error && errors.length < maxBufferedErrors) errors.push(value);
  };
  const onError = (event: ErrorEvent) => remember(event.error);
  const onRejection = (event: PromiseRejectionEvent) => remember(event.reason);
  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onRejection);
  const detach = () => {
    window.removeEventListener('error', onError);
    window.removeEventListener('unhandledrejection', onRejection);
  };

  void load()
    .then(({ initializeBrowserErrors }) => {
      detach();
      initializeBrowserErrors(dsn, errors);
    })
    .catch(() => {
      detach();
    });
}
